<template>
  <div class="container">
    <div class="row mb-5">
      <div class="col-12">
        <input
          type="text"
          class="form-control wfh-version m-auto"
          placeholder='Try searching "Fave" or "Malaysia"'
          v-model="q"
          v-bind:class="{ 'bg-white': origin !== 'dashboard' }"
        />
      </div>
    </div>
    <div class="row" v-if="companies.length > 0">
      <div
        class="col-12 col-md-6 col-lg-4"
        v-for="company in companies"
        :key="company.id"
      >
        <div class="companies-card" @click="getCompanyDetail(company.id)">
          <div class="company-details">
            <div class="company-image">
              <img
                v-if="company.logo_src"
                v-bind:src="company.logo_src"
                alt="Company Logo"
                style="width: 100%"
              />
            </div>

            <div class="company-rating">
              <div class="company-name">
                <p v-text="company.name"></p>
              </div>
              <div
                style="display: inline-block"
                v-if="parseInt(rating(company)) > 70"
              >
                <div
                  class="green-rating"
                  v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                  :key="`green-${i}`"
                ></div>
                <div
                  class="null-rating"
                  v-for="i in 10 - Math.floor(parseInt(rating(company)) / 10)"
                  :key="`null-green-${i}`"
                ></div>
              </div>
              <div
                style="display: inline-block"
                v-else-if="parseInt(rating(company)) > 30"
              >
                <div
                  class="yellow-rating"
                  v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                  :key="`yellow-${i}`"
                ></div>
                <div
                  class="null-rating"
                  v-for="i in 10 - Math.floor(parseInt(rating(company)) / 10)"
                  :key="`null-yellow-${i}`"
                ></div>
              </div>
              <div
                style="display: inline-block"
                v-else-if="parseInt(rating(company)) <= 30"
              >
                <div
                  class="red-rating"
                  v-for="i in Math.floor(parseInt(rating(company)) / 10)"
                  :key="`red-${i}`"
                ></div>
                <div
                  class="null-rating"
                  v-for="i in 10 - Math.floor(parseInt(rating(company)) / 10)"
                  :key="`null-red-${i}`"
                ></div>
              </div>
              <div
                style="display: inline-block"
                v-else-if="!parseInt(rating(company))"
              >
                <div
                  class="null-rating"
                  v-for="i in 10"
                  :key="`null-${i}`"
                ></div>
              </div>
              <p class="company-remote-percentage">
                {{ rating(company) }} Remote friendly
              </p>
            </div>
          </div>

          <div class="company-description">
            <div class="row" style="height: 83px">
              <div class="col-6">
                <span class="desc-heading">Location</span>
                <p class="desc-sub">
                  {{ company.city }},
                  {{ company.country }}
                </p>
              </div>
              <div class="col-6">
                <span class="desc-heading">WFH Status</span>
                <p class="desc-sub" v-text="getWorkFromHome(company)"></p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <span class="desc-heading">Travel</span>
                <p class="desc-sub" v-text="getTravel(company)"></p>
              </div>
              <div class="col-6">
                <span class="desc-heading">Visitors</span>
                <p class="desc-sub" v-text="getVisitors(company)"></p>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <span class="desc-heading">Events</span>
                <p class="desc-sub" v-text="getEvents(company)"></p>
              </div>
              <div class="col-6 actions">
                <span class="updated-at"
                  >Updated {{ getReadableTime(company.updated_at) }}</span
                >
                <button class="btn btn-primary">
                  <img v-bind:src="'/images/arrow_right.png'" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="companies.length === 0" class="row">
      <div class="companies-card empty"></div>
    </div>
    <div class="row">
      <button
        type="submit"
        class="btn btn-primary m-auto"
        v-if="paginator.current_page < paginator.last_page"
        @click="getNextSetOfRecords"
      >
        <img v-bind:src="'/images/_add.png'" width="22px" class="mr-2" />Load
        more results
      </button>
    </div>
  </div>
</template>

<script>
import DropDownOptions from "./DropdownOptionsConfig";
import remoteReadinessRating from "./RemoteReadinessRating";

export default {
  props: ["origin"],

  data() {
    return {
      data: {},
      companies: [],
      modalCurrentCompany: {},
      displayableCompanyDetails: {},
      displayableRemoteMeasures: {},
      skipKeys: [
        "id",
        "company_id",
        "needs_help_remote_ready",
        "created_at",
        "updated_at",
      ],
      dropDownOptions: DropDownOptions,
      paginator: {
        from: 1,
        last_page: 1,
        per_page: 12,
        to: 4,
        total: 4,
        current_page: 1,
      },
      q: "",
    };
  },

  watch: {
    "paginator.current_page"() {
      if (
        this.paginator.current_page > this.paginator.last_page ||
        this.paginator.current_page < 1
      )
        this.paginator.current_page = 1;

      this.getActiveCompanies();
    },

    q() {
      this.executeSearch();
    },
  },

  methods: {
    executeSearch: _.debounce(async function () {
      this.companies = [];
      await this.getActiveCompanies(true);
    }, 500),

    async getActiveCompanies(refresh = false) {
      if (refresh) {
        this.paginator = {
          from: 1,
          last_page: 1,
          per_page: 12,
          to: 4,
          total: 4,
          current_page: 1,
        };
      }

      const url =
        "/company?page=" + (this.paginator.current_page || 1) + "&q=" + this.q;
      this.data = await axios.get(url).then((data) => data.data.data);

      this.data.data.forEach((item) => this.companies.push(item));

      const mapKeys = ["from", "last_page", "per_page", "to", "total"].forEach(
        (key) => (this.paginator[key] = this.data[key])
      );
    },

    rating(company) {
      if (!company.remote_measures) return "–";

      const score = remoteReadinessRating(company.remote_measures);

      return score + "%";
    },

    getReadableTime(updatedAt) {
      return moment(updatedAt, "YYYY-MM-DDTHH:mm:ss").fromNow();
    },

    getCompanyDetail(companyId) {
      if (this.origin && this.origin === "dashboard") {
        this.$emit("viewCompanyDetails", companyId);
      } else {
        location.href = `/company/${companyId}`;
      }
    },

    isEmptySearchResults() {
      return this.companies.length == 0 && !!this.q;
    },

    getNextSetOfRecords() {
      this.paginator.current_page++;
    },

    getPreviousSetOfRecords() {
      this.paginator.current_page--;
    },

    getPaginationText() {
      return (
        "Showing " +
        this.paginator.from +
        " – " +
        this.paginator.to +
        " out of " +
        this.paginator.total
      );
    },

    getWorkFromHome(company) {
      return DropDownOptions["wfhOptions"][company.allow_work_from_home];
    },

    getTravel(company) {
      return DropDownOptions["travelOptions"][company.allow_travel];
    },

    getVisitors(company) {
      return DropDownOptions["visitorOptions"][company.allow_visitors];
    },

    getEvents(company) {
      return DropDownOptions["eventsOptions"][company.allow_events];
    },
  },

  mounted() {
    this.getActiveCompanies();
  },
};
</script>
